// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3hXeI","disabled":"FileBtn_disabled__1CVbp","warn":"FileBtn_warn__VKYRZ","fade":"FileBtn_fade__32Vw5"};